<template>
<div>
  <!--
  {{this.series}}***
  {{this.Item_Inputdata}}
  {{this.series}}***
  {{ctrldata}}-->
  <apexchart
          height="400"
          type="bubble"
          :options="chartOptions"
          :series="series"
        ></apexchart></div>
  
</template>

<script>
import { bus } from "../../../../main";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  name: "BubbleExample",
  props: {
    ctrldata: [],
  },
  data: function () {
    return {
      tempctrldata: [],
      chartOptions: {
        chart: {
          type: "bubble",
          toolbar: {
            show: true,
          },
          fontFamily: "Lato",
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            distributed: true,
            barHeight: "50%",
            horizontal: true,
          },
          bubble: {
            // minBubbleRadius: 25,
            // maxBubbleRadius: 50,
          }
        },
        grid: {
          yaxis: {
            lines: {
              show: true,
            },
          },
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          show: true,
          title: {
            text: "ROI",
            style: {
              color: "#9AA1A9",
            },
          },
          type: 'numeric',
          labels: {
            style: {
              colors: "#9AA1A9",
            },
          },
        },
        yaxis: {
          show: true,
          title: {
            text: "Spend",
            style: {
              color: "#9AA1A9",
            },
          },
          labels: {
            style: {
              colors: ["#9AA1A9"],
            },
            formatter: (value) => new Intl.NumberFormat("en").format(value),
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
        },
        tooltip: {
          inverseOrder: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return (
              "<div class='arrow_box' style='font-family: Lato'>" +
              "<div style='margin-bottom: 5px; font-weight: bold; background: #f3f5f8; padding: 10px; border-bottom: 1px solid lightgrey'>" +
              w.globals.seriesNames[seriesIndex] +
              "</div>" +
              "<div style='padding-left: 10px'>" +
              'ROI: ' + "<span style='font-weight: bold'>" + w.globals.seriesX[seriesIndex][0] + "</span>" +
              "</div>" +
              "<div style='padding-left: 10px;padding-right: 10px; padding-top: 5px'>" +
              'Spend: ' + "<span style='font-weight: bold'>" + new Intl.NumberFormat('en').format(series[seriesIndex][dataPointIndex]) + "</span>" +
              "</div>" +
              "<div style='padding: 5px 10px 5px 10px'>" +
              'Volume Contribution: ' + "<span style='font-weight: bold'>" + new Intl.NumberFormat('en').format(w.globals.seriesZ[seriesIndex][0]) + "%</span>" +
              "</div>" +
              "</div>"
            );
          },
        },
      },
      series: [],
      seriesold: [],
      Item_Spend: [],
      Item_volume_contribution: [],
      Item_roi: [],
      Item_roi_activity12: [],
      Item_Inputdata: [],
    };
  },
  methods: {
    getdate() {
      this.Item_roi_activity12 = [];
      this.Item_Inputdata=[];

      //let tempdata1 =  this.tempctrldata.filter(a=>a.region == 'national') ;
      let tempdata1 = this.tempctrldata;
      for (var k = 0; k < tempdata1.length; k++) {
        if (tempdata1[k].region == "national") {
          
          this.Item_Inputdata.push(tempdata1[k]);
        }
      }
      for (var i = 0; i < this.Item_Inputdata.length; i++) {
         if (this.Item_Inputdata[i].variable != "base") {
        let obj = new Object();
        obj.name = this.Item_Inputdata[i].variable;
        let tempdataArray = [];
        var x = this.Item_Inputdata[i].roi;
        var y = this.Item_Inputdata[i].spend;
        var z = this.Item_Inputdata[i].volume_contribution;
/*
        var x = this.Item_Inputdata[i].spend;
        var y = this.Item_Inputdata[i].volume_contribution;
        var z = this.Item_Inputdata[i].roi;
*/

        tempdataArray.push([x, y, z]);
        obj.data = tempdataArray;
        this.Item_roi_activity12.push(obj);}
      }
      this.binddataNew();
    },

    binddataNew() {
      this.series=[];
      this.series = this.Item_roi_activity12;
    },
    binddata() {
      this.seriesold = [
        {
          name: "Spend",
          data: this.generateData(new Date("11 Feb 2017 GMT").getTime(), 20, {
            min: 10,
            max: 60,
          }),
        },
        {
          name: "volume_contribution",
          data: this.generateData(new Date("11 Feb 2017 GMT").getTime(), 20, {
            min: 10,
            max: 60,
          }),
        },
        {
          name: "roi",
          data: this.generateData(new Date("11 Feb 2017 GMT").getTime(), 20, {
            min: 10,
            max: 60,
          }),
        },
      ];
    },
    generateData(baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < 1) {
        var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
        var y =
          Math.floor(Math.random() * (yrange.max - yrange.min + 1)) +
          yrange.min;
        var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;
        series.push([x, y, z]);
        baseval += 86400000;
        i++;
      }
      return series;
    },
    refresh() {
      //alert('refreshpiechart');
      this.getdate();
      //this.binddata();
    },
  },
  mounted() {
    this.getdate();
    //this.binddata();
    bus.$off("refreshChartBubble");
    // alert('dd');
    bus.$on("refreshChartBubble", this.refresh);
  },
  computed: {
    options() {
      return {
        chart: {
          type: "bubble",
          toolbar: {
            show: true,
          },
          fontFamily: "Lato",
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            distributed: true,
            barHeight: "50%",
            horizontal: true,
          },
          bubble: {
            // minBubbleRadius: 25,
            // maxBubbleRadius: 50,
          }
        },
        grid: {
          yaxis: {
            lines: {
              show: true,
            },
          },
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          show: true,
          title: {
            text: "ROI",
            style: {
              color: "#9AA1A9",
            },
          },
          type: 'numeric',
          labels: {
            style: {
              colors: "#9AA1A9",
            },
          },
        },
        yaxis: {
          show: true,
          title: {
            text: "Spend",
            style: {
              color: "#9AA1A9",
            },
          },
          labels: {
            style: {
              colors: ["#9AA1A9"],
            },
            formatter: (value) => new Intl.NumberFormat("en").format(value),
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
        },
        tooltip: {
          inverseOrder: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return (
              "<div class='arrow_box' style='font-family: Lato'>" +
              "<div style='margin-bottom: 5px; font-weight: bold; background: #f3f5f8; padding: 10px; border-bottom: 1px solid lightgrey'>" +
              w.globals.seriesNames[seriesIndex] +
              "</div>" +
              "<div style='padding-left: 10px'>" +
              'ROI: ' + "<span style='font-weight: bold'>" + w.globals.seriesX[seriesIndex][0] + "</span>" +
              "</div>" +
              "<div style='padding-left: 10px; padding-top: 5px'>" +
              'Spend: ' + "<span style='font-weight: bold'>" + new Intl.NumberFormat('en').format(series[seriesIndex][dataPointIndex]) + "</span>" +
              "</div>" +
              "<div style='padding: 5px 10px 5px 10px'>" +
              'Volume Contribution: ' + "<span style='font-weight: bold'>" + w.globals.seriesZ[seriesIndex][0] + '%' + "</span>" +
              "</div>" +
              "</div>"
            );
          },
        },
      };
    },
  },
  watch: {
    ctrldata: function (val) {
      // alert('Onoad -' + val);
      if (val) {
        this.tempctrldata = this.ctrldata;
        this.getdate();
        this.binddata();
      }
    },
  },
};
</script>

<style scoped>
.notediv {
  text-align: left;
  font-weight: bold;
}

.headerboxtitle {
  font-size: 20px;
}

.card4 {
  background-color: #dc3545;
  color: white;
}
</style>
